import { Button } from "antd";

import FeatureImage from "../../assets/images/feature-product-image.png";
import CoineImage from "../../assets/images/header-coin-icon.svg";
import { Link } from "react-router-dom";

const CartSummary = ({ checkoutData, handleSubmit, promoCode }) => {
  return (
    <div className="cart-summary">
      <div className="cart-summary-header">
        <h6>Cart</h6>
        <Link>Edit</Link>
      </div>
      <div className="cart-images">
        {checkoutData?.items?.map((item, i) => (
          <img key={i} src={item?.image} alt="item" className="cart-item-img" />
        ))}
        <span className="more-items">{checkoutData?.items?.length}</span>
      </div>

      <div className="cart-totals">
        <div className="cart-total-listing">
          <div className="cart-totals-leftmenu">
            Total tokens <span>({checkoutData?.items?.length} items)</span>
          </div>{" "}
          <div className="cart-totals-rightmenu">
            <img src={CoineImage} alt="item" />
            {checkoutData?.totalTokens}
          </div>
        </div>
        <div className="cart-total-listing">
          <div className="cart-totals-leftmenu">Shipping fee</div>{" "}
          <div className="cart-totals-rightmenu">
            <img src={CoineImage} alt="item" />
            {checkoutData?.shippingFee}
          </div>
        </div>
        <div className="cart-total-listing">
          <div className="cart-totals-leftmenu">Grand total</div>{" "}
          <div className="cart-totals-rightmenu">
            <img src={CoineImage} alt="item" />
            {checkoutData?.grandTotal}
          </div>
        </div>
        <div className="tokens-pay">
          <div className="cart-totals-leftmenu">TOKENS TO PAY</div>{" "}
          <div className="cart-totals-righttotal">
            {checkoutData?.grandTotal}
          </div>
        </div>
      </div>

      <Button className="Fill-button" htmlType="submit">
        Place Order
      </Button>
    </div>
  );
};

export default CartSummary;
